"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.Consumer = exports.ConsumesUsageTrackerContext = exports.propType = void 0;

var _react = require("react");

var _consumerDecoratorFactory = _interopRequireDefault(require("./consumerDecoratorFactory"));

var propType = _react.PropTypes.shape({
  track: _react.PropTypes.func.isRequired,
  clone: _react.PropTypes.func,
  setProperties: _react.PropTypes.func
});

exports.propType = propType;

var _createContext = (0, _react.createContext)(),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.Provider = Provider;
exports.Consumer = Consumer;
var ConsumesUsageTrackerContext = (0, _consumerDecoratorFactory.default)('usageTracker', Consumer, 'usageTracker');
exports.ConsumesUsageTrackerContext = ConsumesUsageTrackerContext;